<template>
  <div class="schedule-transfer-container">
    <!-- 左侧列表：车辆数据 -->
    <div class="transfer-panel">
      <div class="panel-header">
        <el-checkbox
          :disabled="isDisabled"
          :indeterminate="leftIsIndeterminate" 
          v-model="leftCheckAll" 
          @change="handleLeftCheckAllChange"
        >应用车辆</el-checkbox>
        <span class="count">{{ leftCheckList.length }}/{{ leftPagination.total }}</span>
      </div>
      <div style="padding: 0 10px;">
        <el-input
        :disabled="isDisabled"
        v-model="carId"
        placeholder="请输入内容"
        class="search-input"
        @input="handleLeftSearch"
      ></el-input>
      <div class="checkbox-list">
        <el-checkbox-group v-model="leftCheckList" @change="handleLeftCheckChange">
          <el-checkbox 
            :disabled="isDisabled"
            v-for="item in getLeftPageData()" 
            :key="item.key" 
            :label="item.key"
            class="checkbox-item"
          >
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      </div>
      <div class="pagination">
        <el-button 
          type="text" 
          size="mini" 
          :disabled="leftPagination.currentPage === 1"
          @click="handleLeftPrevPage"
        >
          上一页
        </el-button>
        <el-button 
          type="text" 
          size="mini" 
          :disabled="leftPagination.currentPage >= leftPagination.totalPages"
          @click="handleLeftNextPage"
        >
          下一页
        </el-button>
      </div>
    </div>

    <!-- 右侧列表：司机数据 -->
    <div class="transfer-panel">
      <div class="panel-header">
        <el-checkbox 
          :disabled="isDisabled"
          :indeterminate="rightIsIndeterminate" 
          v-model="rightCheckAll" 
          @change="handleRightCheckAllChange"
        >应用司机</el-checkbox>
        <span class="count">{{ rightCheckList.length }}/{{ rightPagination.total }}</span>
      </div>
      <div style="padding: 0 10px;">
        <el-input 
        :disabled="isDisabled"
        v-model="driverName"
        placeholder="请输入内容"
        class="search-input"
        @input="handleRightSearch"
      ></el-input>
      <div class="checkbox-list">
        <el-checkbox-group v-model="rightCheckList" @change="handleRightCheckChange">
          <el-checkbox 
            :disabled="isDisabled"
            v-for="item in getRightPageData()" 
            :key="item.key" 
            :label="item.key"
            class="checkbox-item"
          >
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      </div>
      <div class="pagination">
        <el-button 
          type="text" 
          size="mini" 
          :disabled="rightPagination.currentPage === 1"
          @click="handleRightPrevPage"
        >
          上一页
        </el-button>
        <el-button 
          type="text" 
          size="mini" 
          :disabled="rightPagination.currentPage >= rightPagination.totalPages"
          @click="handleRightNextPage"
        >
          下一页
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scheduleTransfer',
  props: {
    // 可以接收初始选中的车辆和司机数据
    initialCarIds: {
      type: Array,
      default: () => []
    },
    initialDriverIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isDisabled: false,
      // 左侧列表（车辆）数据
      leftData: {
        all: [], // 所有车辆数据
        filtered: [], // 搜索过滤后的车辆数据
        loading: false
      },
      carId: '',
      leftCheckAll: false,
      leftIsIndeterminate: false,
      leftCheckList: [],
      leftPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0
      },

      // 右侧列表（司机）数据
      rightData: {
        all: [], // 所有司机数据
        filtered: [], // 搜索过滤后的司机数据
        loading: false
      },
      driverName: '',
      rightCheckAll: false,
      rightIsIndeterminate: false,
      rightCheckList: [],
      rightPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0
      }
    };
  },
  created() {
    this.initData();
    // 设置初始选中的数据
    this.leftCheckList = [...this.initialCarIds];
    this.rightCheckList = [...this.initialDriverIds];
    this.updateLeftCheckStatus();
    this.updateRightCheckStatus();
  },
  methods: {
    // 初始化数据
    async initData() {
      await Promise.all([
        this.loadCarData(),
        this.loadDriverData()
      ]);
      this.updatePagination();
    },

    // 加载车辆数据
    loadCarData() {
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        carId: this.carId,
        pageNum: this.leftPagination.currentPage,
        pageSize: 10 // 一次性加载足够多的数据，前端分页
      };
      this.leftData.loading = true;
      return this.$store.dispatch('ShiftSchedule/GET_CHOICESHIFTCAR', param).then(res => {
        this.leftData.loading = false;
        if (res && res.data.code === 200) {
          const data = res.data.data.list.map(item => ({
            key: item.carId,
            label: item.carId
          }));
          this.leftData.all = data;
          this.leftData.filtered = [...data];
          this.leftPagination.total = res.data.data.total;
          this.updatePagination();
        }
      }).catch(err => {
        this.leftData.loading = false;
        console.error('加载车辆数据失败:', err);
      });
    },

    // 加载司机数据
    loadDriverData() {
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        driverName: this.driverName,
        pageNum: this.rightPagination.currentPage,
        pageSize: 10 // 一次性加载足够多的数据，前端分页
      };
      this.rightData.loading = true;
      return this.$store.dispatch('ShiftSchedule/GET_CHOICESHIFTDRIVER', param).then(res => {
        this.rightData.loading = false;
        if (res && res.data.code === 200) {
          const data = res.data.data.list.map(item => ({
            key: item.driverNum,
            label: item.name
          }));
          this.rightData.all = data;
          this.rightData.filtered = [...data];
          this.rightPagination.total = res.data.data.total;
          this.updatePagination();
        }
      }).catch(err => {
        this.rightData.loading = false;
        console.error('加载司机数据失败:', err);
      });
    },

    // 更新分页信息
    updatePagination() {
      // 左侧分页 - 基于后台返回的总数计算
      this.leftPagination.totalPages = Math.ceil(this.leftPagination.total / this.leftPagination.pageSize);
      this.leftPagination.currentPage = Math.min(this.leftPagination.currentPage, this.leftPagination.totalPages || 1);

      // 右侧分页 - 基于后台返回的总数计算
      this.rightPagination.totalPages = Math.ceil(this.rightPagination.total / this.rightPagination.pageSize);
      this.rightPagination.currentPage = Math.min(this.rightPagination.currentPage, this.rightPagination.totalPages || 1);
    },

    // 获取左侧当前页数据
    getLeftPageData() {
      // 这里不需要再做前端分页，因为现在是通过接口分页获取数据
      // 直接返回当前加载的数据即可
      return this.leftData.filtered;
    },

    // 获取右侧当前页数据
    getRightPageData() {
      // 这里不需要再做前端分页，因为现在是通过接口分页获取数据
      // 直接返回当前加载的数据即可
      return this.rightData.filtered;
    },

    // 左侧搜索
    handleLeftSearch() {
      console.log(this.carId)
      if (this.carId) {
        // 搜索时，重新从第一页开始查找
        this.leftPagination.currentPage = 1;
        // 重新加载数据，搜索逻辑应该由后端处理
        this.loadCarData();
      } else {
        // 清空搜索时，重新加载第一页数据
        this.leftPagination.currentPage = 1;
        this.loadCarData();
      }
    },

    // 右侧搜索
    handleRightSearch() {
      if (this.driverName) {
        // 搜索时，重新从第一页开始查找
        this.rightPagination.currentPage = 1;
        // 重新加载数据，搜索逻辑应该由后端处理
        this.loadDriverData();
      } else {
        // 清空搜索时，重新加载第一页数据
        this.rightPagination.currentPage = 1;
        this.loadDriverData();
      }
    },

    // 左侧全选
    handleLeftCheckAllChange(val) {
      if (val) {
        // 全选当前页的所有数据
        const currentPageData = this.getLeftPageData();
        this.leftCheckList = [...new Set([...this.leftCheckList, ...currentPageData.map(item => item.key)])];
      } else {
        // 取消选中当前页的所有数据
        const currentPageData = this.getLeftPageData();
        this.leftCheckList = this.leftCheckList.filter(carId => 
          !currentPageData.some(item => item.key === carId)
        );
      }
      this.leftIsIndeterminate = false;
      this.$emit('car-change', this.leftCheckList);
    },

    // 右侧全选
    handleRightCheckAllChange(val) {
      if (val) {
        // 全选当前页的所有数据
        const currentPageData = this.getRightPageData();
        this.rightCheckList = [...new Set([...this.rightCheckList, ...currentPageData.map(item => item.key)])];
      } else {
        // 取消选中当前页的所有数据
        const currentPageData = this.getRightPageData();
        this.rightCheckList = this.rightCheckList.filter(driverNum => 
          !currentPageData.some(item => item.key === driverNum)
        );
      }
      this.rightIsIndeterminate = false;
      this.$emit('driver-change', this.rightCheckList);
    },

    // 左侧选中项变化
    handleLeftCheckChange() {
      this.updateLeftCheckStatus();
      // console.log(this.leftCheckList)
      this.$emit('car-change', this.leftCheckList);
    },

    // 右侧选中项变化
    handleRightCheckChange() {
      this.updateRightCheckStatus();
      this.$emit('driver-change', this.rightCheckList);
    },

    // 更新左侧全选状态
    updateLeftCheckStatus() {
      const currentPageData = this.getLeftPageData();
      
      // 检查当前页的选中状态
      const currentPageCheckedCount = currentPageData.filter(item => 
        this.leftCheckList.includes(item.key)
      ).length;
      
      // 检查所有已加载数据的选中状态（all数组包含了所有已加载的数据）
      const allCheckedCount = this.leftData.all.filter(item => 
        this.leftCheckList.includes(item.key)
      ).length;
      
      // 只有当所有已加载的数据都被选中时，全选按钮才显示为选中状态
      this.leftCheckAll = allCheckedCount === this.leftData.all.length && this.leftData.all.length > 0;
      
      // 半选状态：当前页部分选中，但不是全部
      this.leftIsIndeterminate = currentPageCheckedCount > 0 && currentPageCheckedCount < currentPageData.length;
    },

    // 更新右侧全选状态
    updateRightCheckStatus() {
      const currentPageData = this.getRightPageData();
      
      // 检查当前页的选中状态
      const currentPageCheckedCount = currentPageData.filter(item => 
        this.rightCheckList.includes(item.key)
      ).length;
      
      // 检查所有已加载数据的选中状态（all数组包含了所有已加载的数据）
      const allCheckedCount = this.rightData.all.filter(item => 
        this.rightCheckList.includes(item.key)
      ).length;
      
      // 只有当所有已加载的数据都被选中时，全选按钮才显示为选中状态
      this.rightCheckAll = allCheckedCount === this.rightData.all.length && this.rightData.all.length > 0;
      
      // 半选状态：当前页部分选中，但不是全部
      this.rightIsIndeterminate = currentPageCheckedCount > 0 && currentPageCheckedCount < currentPageData.length;
    },

    // 左侧上一页
    handleLeftPrevPage() {
      if (this.leftPagination.currentPage > 1) {
        this.leftPagination.currentPage--;
        this.loadCarData(); // 重新加载上一页数据
        // 保持选中状态
        // this.updateLeftCheckStatus();
      }
    },

    // 左侧下一页
    handleLeftNextPage() {
      if (this.leftPagination.currentPage < this.leftPagination.totalPages) {
        this.leftPagination.currentPage++;
        this.loadCarData(); // 重新加载下一页数据
        // 保持选中状态
        // this.updateLeftCheckStatus();
      }
    },

    // 右侧上一页
    handleRightPrevPage() {
      if (this.rightPagination.currentPage > 1) {
        this.rightPagination.currentPage--;
        this.loadDriverData(); // 重新加载上一页数据
        // 保持选中状态
        // this.updateRightCheckStatus();
      }
    },

    // 右侧下一页
    handleRightNextPage() {
      if (this.rightPagination.currentPage < this.rightPagination.totalPages) {
        this.rightPagination.currentPage++;
        this.loadDriverData(); // 重新加载下一页数据
        // 保持选中状态
        // this.updateRightCheckStatus();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.schedule-transfer-container {
  display: flex;
  gap: 20px;
  // padding: 10px;
}

.transfer-panel {
  flex: 1;
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  width: 205px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 10px;
  background-color: #e8e8e8;
  border-bottom: 1px solid #d7d7d7;
}

.count {
  font-size: 12px;
  color: #606266;
}

.search-input {
  margin-bottom: 10px;

  ::v-deep .el-input__inner {
    width: 100% !important;
    border-radius: 15px !important;
  }
}

.checkbox-list {
  max-height: 350px;
  overflow-y: auto;
  margin-bottom: 10px;
}

.checkbox-item {
  display: block;
  width: 100%;
  margin-bottom: 5px;
}

.pagination {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  background-color: #e8e8e8;
  border-color: #d7d7d7;
  .el-button {
      // width: 50% !important;
      background-color: transparent !important;
      color: #409eff !important;
      height: 40px !important;
      line-height: 40px !important;
      margin-left: 0;
    }
    .el-button.is-disabled {
      color: #aeaeae !important;
    }
}

::v-deep .el-checkbox__label {
  display: inline-block;
  word-break: break-all;
  color: #555555;
        font-size: 14px;
}
</style>